<template>
  <div class="search_left full_height">
    <div class="common_search">
      <div class="inlineBlock">
        <el-select v-model="moduleSearch" placeholder="Please choose" @change="changeSelectSearch">
          <el-option
            v-for="item in searchOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="inlineBlock">
        <el-input
          placeholder="Please enter content"
          v-model="keyword"
          class="input-with-select"
          @keyup.enter.native="searchData"
        >
          <el-button slot="append" icon="el-icon-search" @click="searchData"></el-button>
        </el-input>
      </div>
    </div>

    <div
      class="components common_left"
      v-loading="loading"
      element-loading-spinner="fa fa-spinner fa-pulse fa-2x mt-3"
    >
      <component
        :is="currentCom"
        ref="com"
        :lists="commonList"
        :total="total"
        v-if="currentCom"
        @search="commonSearch"
      >
        <template slot="tag">
          <span class="tag_item_left">{{comName}}</span>
        </template>
      </component>
      <div v-else class="no_data_container">
        <span class="img no_data_img"></span>
        <p>Sorry, No data was found</p>
      </div>
    </div>
  </div>
</template>

<script>
import searchOptions from "../conf/SearchOptions";
import {
  getCompanyList,
  getZephyrList,
  getIndictorsList,
  getMacroCommon,
  getPatentList
} from "common/js/http/v2Api";

import wordMap from "conf/macroChinese.js";
import { mapMutations} from "vuex";
// const patentDataConfig = require("../conf/patent");

// 根据后台字段 修改   组件
const comMap = {
  Macro: "Macro",
  Industry: "Industry",
  Company: "Company",
  "M&A transactions": "Transaction"
};

export default {
  name: "DataLeft",
  // props:["title","name"],
  data() {
    return {
      searchOptions,
      moduleSearch: "",
      keyword: "",
      currentCom: "",
      comName: "",
      // 组件search相关
      commonList: [],
      total: 0,
      commonQuery: {},
      macroSearchIndex: 0,
      isMobilePhone: false,
      loading: false
    };
  },

  created() {
    // this.searchData();
    this.initModule();
  },

  methods: {
    initModule() {
      const path = this.$route.path.split("/");
      // 存在右侧的子路由 则设置回显
      if (path[3]) {
        this.comName = path[3];
        this.currentCom = this.requireComponents(this.comName);
        this.moduleSearch = Object.keys(comMap).filter(
          item => comMap[item] == this.comName
        )[0];
      } else {
        this.moduleSearch = "Company";
        this.changeSelectSearch();
      }
    },

    changeSelectSearch() {
      this.keyword = "";
      this.macroSearchIndex = 0;
      // this.searchData();
      this.comName = comMap[this.moduleSearch];
      this.currentCom = this.requireComponents(this.comName);
      this.$router.push(`/data/SearchModule/${this.comName}`);

      // 显示主页
      this.changeIndexShow(true);
    },

    searchData() {
      // this.comName = comMap[this.moduleSearch];
      // console.log("TCL: searchData -> this.comName", this.comName)
      // this.currentCom = this.requireComponents(this.comName);
      // this.$router.push(`/data/SearchModule/${this.comName}`);
      const map = {
        Macro: "macroSearch",
        Industry: "industrySearch",
        Company: "companySearch",
        "M&A transactions": "transcationSearch",
        Patent: "patentSearch"
      };
      const fn = map[this.moduleSearch];
      this.commonQuery.keyword = this.keyword;
      this[fn]();
    },

    requireComponents(com) {
      const component = resolve =>
        require([`@/views/silkRoadV2Data/components/comLeft/${com}`], resolve);
      return component;
    },

    commonSearch(key, value) {
      this.loading = true;
      if (key == "macro") {
        //默认第一次 关键字GDP  输入栏不能显示 所以不能直接指定this.keyword
        if (this.macroSearchIndex == 0) {
          this.keyword = "GDP";
        }
        this.macroSearchIndex++;
      }
      this.commonQuery = Object.assign(this.$lodash.cloneDeep(value), {
        keyword: this.keyword
      });
      // if (key == "macro") {
      //   //默认第一次 关键字GDP  输入栏不能显示 所以不能直接指定this.keyword
      //   if (this.macroSearchIndex == 0) {
      //     this.commonQuery.keyword = "GDP";
      //   }
      //   this.macroSearchIndex++;
      // }

      const keyFn = key + "Search";
      this[keyFn](value);
    },

    // 企业列表emit
    async companySearch(val) {
      const { result } = await getCompanyList(this.commonQuery);
      this.commonList = result.recordList;
      this.total = result.recordCount;
      this.loading = false;
    },

    // 并购交易11
    async transcationSearch(val) {
      console.log("transcationSearch -> val", val);
      const { result } = await getZephyrList(this.commonQuery);
      this.loading = false;

      result.recordList.forEach(item => {
        try {
          //数据包含json 或者字符串要分开处理  避免数据原因造成程序报错 返回[]
          if (item.target.includes("{") && item.target.includes("}")) {
            item.target = JSON.parse(item.target).map(item => item.target_name);
            item.vendor = JSON.parse(item.vendor).map(item => item.vendor_name);
            item.acquiror = JSON.parse(item.acquiror).map(
              item => item.acquiror_name
            );
          } else {
            item.target = item.target.split(",").map(item => {
              const itemData = item.split(";");
              let target = "";
              itemData.forEach(j => {
                if (j.includes("target_name")) {
                  target = j.split(":")[1];
                }
              });
              return target;
            });
            item.vendor = item.vendor.split(",").map(item => {
              const itemData = item.split(";");
              let target = "";
              itemData.forEach(j => {
                if (j.includes("vendor_name")) {
                  target = j.split(":")[1];
                }
              });
              return target;
            });
            item.acquiror = item.acquiror.split(",").map(item => {
              const itemData = item.split(";");
              let target = "";
              itemData.forEach(j => {
                if (j.includes("acquiror_name")) {
                  target = j.split(":")[1];
                }
              });
              return target;
            });
          }
        } catch (error) {
          item.target = [];
          item.vendor = [];
          item.acquiror = [];
          this.loading = false;
        }
      });
      this.commonList = result.recordList;
      this.total = result.recordCount;
      this.loading = false;
    },

    async industrySearch(val) {
      const level = "3"; //后台固定数值
      const query = Object.assign(this.$lodash.cloneDeep(this.commonQuery), {
        name: this.keyword,
        level,
        userId: parseInt(this.Cookies.get("imsilkroad_userid")),
        userName: this.Cookies.get("imsilkroad_username")
        // userId: 1,
        // userName: "test"
      });
      const { result } = await getIndictorsList(query);
      this.total = result.total;

      // result.list.forEach(item => {

      // });

      this.commonList = result.list;
      this.loading = false;
    },

    // Annual,%20ending%20"Dec"%20of%20each%20year
    // Annual,%20ending%20"Dec"%20of%20each%20year

    // Annual,%20ending%20%22Dec%22%20of%20each%20year
    async macroSearch(val) {
      const params = {
        api: "/api/queryAll.html",
        methodType: "POST",
        params: this.commonQuery,
        userId: parseInt(this.Cookies.get("imsilkroad_userid")),
        userName: this.Cookies.get("imsilkroad_username")
        // userId: 3091,
        // userName: "imtest"
      };

      const { data } = await getMacroCommon(params);
      this.total = data.total;

      const list = data.hits.map(item => ({
        id: item._id,
        name: item._source.cn_name,
        fullName:
          item._source.cn_name + ":" + item._source.country_cn_simplename,
        countryName: item._source.country_cn_simplename,
        frequency: item._source.statperiod_cn_description,
        unit: item._source.unit_cn_description,
        resource: this.testChineseWord(item._source.original_data_source)
      }));
      this.commonList = list;
      this.loading = false;
    },

    async patentSearch(val) {
      // console.log("patentSearch -> val", val);
      const query = this.$lodash.cloneDeep(this.commonQuery);
      query.keyWord = query.keyword;
      const { result } = await getPatentList(query);
      // console.log("patentSearch -> result", result);
      const data = result;
      // const data = patentDataConfig;
      this.total = data.count;
      // console.log("patentSearch -> data.dataArray", data.dataArray);
      const list = data.dataArray.map(item => ({
        id: item._id,
        title: item.title.en
          ? item._id + " " + item.title.en
          : item._id + " " + item.title.original,
        detail: item.abstract.en ? item.abstract.en : item.abstract.original,
        region: item.region
      }));
      this.commonList = list;
      // console.log("patentSearch -> this.commonList", this.commonList);
      this.loading = false;
    },

    //是否包含中文
    testChineseWord(source) {
      //包含汉字
      if (/.*[\u4e00-\u9fa5]+.*$/.test(source)) {
        if (wordMap[source]) return wordMap[source];
      }
      return source;
    },

    isMobile() {
      this.isMobilePhone = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
    },

    ...mapMutations(["changeIndexShow"])
  },

  watch: {
    $route(newValue) {
      console.log("$route -> newValue", newValue)
      const path = newValue.path.split("/");
      if (path.length == 3) {
        this.currentCom = "";
        this.moduleSearch = "";
      }
      // 点击左侧侧边栏 不能正确访问的问题
      const isQuery = Object.keys(newValue.query).length
      if(newValue.fullPath.includes('/Company')&&!isQuery) {
        this.moduleSearch = "Company";
        this.changeSelectSearch();
      }
    }
  }
};
</script>

<style scoped>
.search_left {
  margin-right: 20px;
  background: #ffffff;

  border: 0 solid #4e5671;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);
}

.inlineBlock {
  display: inline-block;
  width: 49%;
  padding: 0px 10px;
}

.common_search {
  padding: 13px 0px 17px 0px;
  border-bottom: 1px solid #e1e1e1;
}

.inlineBlock >>> .input-with-select .el-input__inner {
  /*border-radius: 15px !important;*/
  /*border-right: none !important;*/
  /**/
  border-right: none !important;
  /* border-top-left-radius: 15px !important;
  border-bottom-left-radius: 15px !important; */
}

.inlineBlock >>> .el-input-group__append,
.inlineBlock >>> .el-input-group__prepend {
  /*border-radius:15px !important;*/
  /* border-top-right-radius: 15px !important;
  border-bottom-right-radius: 15px !important; */
  background: #0078ff;
  border: 1px solid #0078ff;
}
.inlineBlock >>> .el-input.is-active .el-input__inner,
.inlineBlock >>> .el-input__inner:focus {
  border-color: #dcdfe6 !important;
  outline: 0;
}

.inlineBlock >>> .el-input-group__append i {
  color: #fff;
  font-weight: 600;
}

.common_left {
  padding: 10px;
  height: 100%;
}
</style>